export default __webpack_public_path__ + "static/media/vid-09.7666b436.mp4";